const INTRO_KEY = "vsgoods_intro_seen_at";
const INTRO_TTL_MS = 7 * 24 * 60 * 60 * 1000; // replay once a week

export function hasSeenIntro() {
  try {
    const seenAt = Number(localStorage.getItem(INTRO_KEY));
    return Boolean(seenAt) && Date.now() - seenAt < INTRO_TTL_MS;
  } catch (e) {
    return true;
  }
}

export function markIntroSeen() {
  try {
    localStorage.setItem(INTRO_KEY, String(Date.now()));
  } catch (e) {}
}

export function resetIntro() {
  try {
    localStorage.removeItem(INTRO_KEY);
  } catch (e) {}
}
